import { ReactElement } from 'react';
import { ROOT } from 'configs/routeNames';
import { Navigate } from 'react-router-dom';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'app/atoms/Can';

export const AuthorizedElement = (props: {
  requiredPermissions: { action: string; subject: string }[];
  redirect?: string;
  component: React.ComponentType;
}): ReactElement => {
  const ability = useAbility(AbilityContext);
  const { requiredPermissions, redirect, component: Component } = props;

  const isAuthorized = requiredPermissions.some((permission) => ability.can(permission.action, permission.subject));

  if (!isAuthorized) {
    return <Navigate to={redirect || ROOT} replace />;
  }

  return <Component />;
};
